/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceAddLocaleLanguageResponse model module.
 * @module model/ServiceAddLocaleLanguageResponse
 * @version version not set
 */
export class ServiceAddLocaleLanguageResponse {
  /**
   * Constructs a new <code>ServiceAddLocaleLanguageResponse</code>.
   * @alias module:model/ServiceAddLocaleLanguageResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceAddLocaleLanguageResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceAddLocaleLanguageResponse} obj Optional instance to populate.
   * @return {module:model/ServiceAddLocaleLanguageResponse} The populated <code>ServiceAddLocaleLanguageResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceAddLocaleLanguageResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceAddLocaleLanguageResponse.prototype.state = undefined;


